<header>
  @if (showNav()) {
  <app-shared-nav></app-shared-nav>
  }
</header>

@if (!showModal) {
<main [class.mt-[8rem]]="showNav()">
  <router-outlet></router-outlet>
</main>
<app-shared-city-modal-floating-city-button></app-shared-city-modal-floating-city-button>
<app-shared-city-modal-floating-whatsapp-button></app-shared-city-modal-floating-whatsapp-button>

<!-- Indicador de venta activa -->
<app-active-sale-indicator></app-active-sale-indicator>

} @else {
<app-shared-city-modal></app-shared-city-modal>
}